import React from "react";
import { Outlet } from "react-router-dom";

// Ctx
import { BuyerMatchProvider } from "contexts/buyer-match";

const BuyerMatch = () => {
  return <Outlet />;
};

const Wrapper = () => {
  return (
    <BuyerMatchProvider>
      <BuyerMatch />
    </BuyerMatchProvider>
  );
};

export default Wrapper;
